import React, { FC } from 'react';
import { CommonProps, ICategory } from './constants';
// eslint-disable-next-line import/no-cycle
import { SingleRow } from './SingleRow';

interface Props extends CommonProps {
  data: Array<ICategory>;
}

export const TableRowsPanel: FC<Props> = ({ data, ...rest }) => (
  <>
    {data.map((category) => (
      <SingleRow key={category.id} category={category} {...rest} />
    ))}
  </>
);
